<template>
  <v-autocomplete solo outlined flat light dense clearable hide-details
                  clear-icon="mdi-close"
                  style="pointer-events: auto; position: relative; width: 300px"
                  v-model="model"
                  :items="items"
                  :filter="v => v"
                  :search-input.sync="searchFormatted"
                  hide-no-data
                  hide-selected
                  item-text="postal_address"
                  item-value="uprn"
                  :label="CONFIG.config.customSearchText || 'Address search'"
                  append-icon="mdi-search"
                  return-object
  >
    <template v-slot:item="{item}">
      <v-list-item @click="goToSelection(item)" class="pcode_item">
        <v-list-item-content>
          <v-list-item-title>{{item.paon}}, {{item.street_name}}</v-list-item-title>
          <v-list-item-subtitle>{{getSubTitle(item)}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
  import color from '@/mixins/color';

  export default {
    name: 'LlpgSearch',

    mixins: [color],

    computed: {
      CONFIG () {
        return this.$store.getters.CONFIG
      },
      primaryColor () {
        return this.$vuetify.theme.themes.light['primary']
      },
      llpgKey () {
        return this.$store.getters['CONFIG'].config.llpgKey
      },
      searchFormatted: {
        get() {
          return this.search;
        },
        set(v) {
          if (v) {
            this.search = v
          }
        },
      },
    },

    watch: {
      search(val) {
        if (!val || val.length < 3) {
          this.searchResults = [];
          return;
        }

        this.sendRequest(val, this);
      },
    },

    methods: {
      getSubTitle(item){
        if (item.locality_name) {
          return `${item.locality_name}, ${item.postcode}`
        } else {
          return item.postcode
        }
      },
      goToSelection(item) {
        console.log("GO TO")
        console.dir(item);
        let mapEPSG = this.$MAP.getView()
          .getProjection()
          .getCode();
        let coords = GOX.Transform([item.easting, item.northing], 'EPSG:27700', mapEPSG);

        this.marker = new GOX.Marker(this.$MAP, coords, 'marker-m1', {
          moveable: false,
          clickable: true,
          style: {
            fill: {
              color: 'red',
            },
            text: {
              value: `${item.paon} (click to remove)`,
              alignment: 'right',
              offsetX: 10,
              color: 'black',
              stroke: {
                color: 'white',
                width: 3
              }
            },
            symbol: {
              size: 5,
              fill: 'red'
            },
            stroke: {
              color: 'white',
            },
          },
        });

        this.marker.on('singleclick', (e) => {
          this.marker.destroy();
        });

        this.$MAP.setCenter(coords, 17);

      },
      sendRequest: _.debounce((val, this_) => {
        console.log(`POSTCODE: ${val}`);
        this_.$store.dispatch('llpg/SEARCH', {key: this_.llpgKey, query: val})
          .then((data) => {
            console.dir(data)
            this_.items = data.lpi;
          });
      }, 300),
    },

    data() {
      return {
        items: [],
        model: null,
        marker: null,
        search: null,
      };
    }
  };
</script>

<style lang="scss">
/*  .v-text-field--filled > .v-input__control > .v-input__slot {
    width: 280px !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
  }*/
  .pcode_item {
    cursor: pointer;
    width: 300px !important;
    &:hover{
      background-color: #ccc;
    }
  }
</style>
